import React from 'react'
import {
  CFImage,
  CFView,
  CFText,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, hero2, hero3, hero4 } from 'images'
import ViewMenuButton from './ViewMenuButton'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          w="100%"
          column
          justifyBetween
          alignCenter
          style={{
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            overflowX: 'hidden',
          }}
        >
          {/* Header */}
          <CFView
            row
            justifyBetween
            alignCenter
            w="100%"
            style={{
              width: '100%',
              boxSizing: 'border-box',
              padding: '30px 15px',
            }}
          >
            <CFView style={{ fontSize: 16 }} color="#111111" helvetica>
              Sushimoto
            </CFView>

            <CFView pulsate textCenter>
              <OrderPickupButton />
            </CFView>

            <ViewMenuButton />
          </CFView>

          {/* First hero */}
          <CFView
            w="100%"
            row
            justifyCenter
            style={{
              width: '100%',
              boxSizing: 'border-box',
            }}
          >
            <CFImage
              src={hero}
              w="80%"
              style={{
                display: 'block',
                maxWidth: '100%',
              }}
            />
          </CFView>

          {/* Second hero with fresh fish label */}
          <CFView
            relative
            w="100%"
            style={{
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
              marginBottom: '-30px',
            }}
          >
            <CFView
              column
              justifyStart
              absolute
              style={{
                top: '34%',
                left: '12%',
                zIndex: 2,
              }}
            >
              <CFText style={{ fontSize: 14 }} color="#111111" helvetica>
                fresh fish
              </CFText>
            </CFView>

            <CFImage
              src={hero2}
              w="100%"
              style={{
                display: 'block',
                width: '100%',
                maxWidth: '100%',
              }}
            />
          </CFView>

          {/* Quiet craft label */}
          <CFView
            w="100%"
            row
            justifyStart
            zIndex={90}
            style={{
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
              padding: '0 15px',
              marginBottom: '10%',
              marginLeft: '50%',
            }}
          >
            <CFText
              style={{
                fontSize: 14,
                whiteSpace: 'nowrap',
              }}
              color="#111111"
              helvetica
            >
              quiet craft
            </CFText>
          </CFView>

          {/* Third hero */}
          <CFView
            w="100%"
            row
            justifyStart
            style={{
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
              paddingLeft: '12%',
            }}
          >
            <CFImage
              w="55%"
              src={hero3}
              style={{
                display: 'block',
                maxWidth: '100%',
              }}
            />
          </CFView>

          {/* Fourth hero with Sushimoto label */}
          <CFView
            w="100%"
            relative
            style={{
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
            }}
          >
            <CFView
              w="100%"
              row
              justifyEnd
              style={{
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
              }}
            >
              <CFImage
                w="40%"
                src={hero4}
                style={{
                  display: 'block',
                  maxWidth: '100%',
                }}
              />
            </CFView>

            <CFView
              column
              justifyStart
              absolute
              style={{
                top: '36%',
                right: '38%',
                zIndex: 2,
              }}
            >
              <CFText style={{ fontSize: 14 }} color="#111111" helvetica>
                sushimoto
              </CFText>
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <Header />
        <CFView w="100%" column center zIndex={90}>
          <CFImage src={hero} w="65%" />
          <CFView relative w="100%" mb="-30px">
            <CFView column justifyStart absolute top="36%" right="80%">
              <CFText style={{ fontSize: 20 }} color="#111111" helvetica>
                fresh fish
              </CFText>
            </CFView>
            <CFImage src={hero2} w="100%" />
          </CFView>
          <CFView w="100%" mb="10%" ml="80%" column justifyStart zIndex={90}>
            <CFText style={{ fontSize: 20 }} color="#111111" helvetica>
              quiet craft
            </CFText>
          </CFView>
          <CFView w="100%" row justifyStart ml="12%">
            <CFImage w="55%" src={hero3} />
          </CFView>
          <CFView w="100%" relative>
            <CFView w="100%" row justifyEnd>
              <CFImage w="40%" src={hero4} />
            </CFView>
            <CFView column justifyStart absolute top="40%" right="38%">
              <CFText style={{ fontSize: 20 }} color="#111111" helvetica>
                sushimoto
              </CFText>
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
